import eventbus from 'tiny-emitter/instance';
import store from '@/store/store';

export default class SelectionRenderer {
  touched = false;
  eventCache = null;
  moved = false;

  constructor(app) {
    this.app = app;
    this.svg = this.app.svg;
    this.setup();
    this.setupEventListeners();
    return this;
  }

  setup() {
    this.bbox = Object.create(null);
    this.selectionRect = this.svg.rect(0, 0);
  }

  setupEventListeners() {
    this.svg.on('mousedown', this.handleMouseDown, this);
    this.svg.on('touchstart', this.handleMouseDown, this);
    eventbus.on('canvas:moved', this.cancelClick, this);
  }

  cancelClick() {
    this.touched = false;
    this.eventCache = null;
    this.svg.off('mouseup', this.handleMouseClick, this);
    this.svg.off('touchend', this.handleMouseClick, this);
    this.svg.off('mousemove', this.handleMouseMove, this);
    this.svg.off('touchmove', this.handleMouseMove, this);
  }

  handleMouseDown(e) {
    if (!this.touched) {
      if (e.button !== 0) return;
      this.touched = true;
      this.eventCache = e;
      this.svg.on('mouseup', this.handleMouseClick, this);
      this.svg.on('mousemove', this.handleMouseMove, this);
      this.svg.on('touchend', this.handleMouseClick, this);
      this.svg.on('touchmove', this.handleMouseMove, this);
    }
  }

  handleMouseMove() {
    if (this.touched) {
      this.moved = true;
    }
  }

  handleMouseClick(e) {
    if (this.app.zoomManager.wasPanning) return this.cancelClick();
    if (e) e.preventDefault();
    if ((e.touches && e.touches.length > 1) || this.moved) {
      // eslint-disable-next-line max-len
      if (
        this.app.isMobileDevice ||
        store.state.seatmap.isPanning ||
        store.state.seatmap.pinchZooming ||
        !store.state.seatmap.isClickable
      ) {
        this.moved = false;
        return;
      }
    }
    const ev = e && e.touches && e.touches.length > 0 ? e : this.eventCache;
    const { x, y } = this.app.getTransformedCoords(ev);
    this.selectionRect.attr({
      x,
      y,
      width: 1,
      height: 1,
    });
    if (e.touches && e.touches.length === 1) {
      const lthis = this;
      this.app.mobileDelayedSelection = setTimeout(() => {
        eventbus.emit('selection:finished', lthis.selectionRect, lthis.moved);
      }, 500);
    } else {
      eventbus.emit('selection:finished', this.selectionRect);
    }
    this.selectionRect.size(0, 0);
    this.cancelClick();
    this.touched = false;
    this.moved = false;
    this.eventCache = null;
  }

  destroyEventListeners() {
    this.svg.off('mousedown', this.handleMouseDown);
    this.svg.off('touchstart', this.handleMouseDown);
    eventbus.off('canvas:moved', this.cancelClick, this);
  }

  destroyObjects() {
    this.selectionRect.remove();
  }

  destroy() {
    this.destroyEventListeners();
    this.destroyObjects();
  }
}
